import { motion, useReducedMotion } from 'framer-motion';
import { pageTransitionProps } from 'constants/animationProps';

const PageTransition = ({ children, className }) => {
  const reduced = useReducedMotion();

  return (
    <motion.div
      initial={reduced ? false : pageTransitionProps.initial}
      animate={pageTransitionProps.animate}
      transition={reduced ? { duration: 0 } : pageTransitionProps.transition}
      className={className}
      style={{ width: '100%', height: '100%' }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
